import { Component, OnInit } from '@angular/core';
import { YoutubeVideo } from 'src/app/models/youtube-video';
import { YoutubeService } from '../../../services/youtube/youtube.service';
import { ToastrService } from 'ngx-toastr';

const YOUTUBE_URL = 'https://www.youtube.com/watch?list=';

@Component({
  selector: 'dashboard-youtube-dialog',
  templateUrl: './youtube-dialog.component.html',
  styleUrls: ['./youtube-dialog.component.scss'],
})
export class YoutubeDialogComponent implements OnInit {
  youTubeVideos: YoutubeVideo[] = [];

  youtubeVideosReady = false;

  constructor(private youtubeService: YoutubeService, private toastrService: ToastrService) {}

  ngOnInit(): void {
    this.youtubeService.getYoutubeVideos().subscribe(
      (data) => this.prepareYoutubeVideos(data),
      (error) => {
        this.toastrService.error('Error in fetching Youtube Videos');
      }
    );
  }

  prepareYoutubeVideos(data: any) {
    const youtubeVideosResponse = data.youTubeVideos.items;
    let preparedYouTubeVideo: YoutubeVideo;
    let videoUrl;
    for (const youtubeVideo of youtubeVideosResponse) {
      videoUrl = `${YOUTUBE_URL}${youtubeVideo.snippet.playlistId}&v=${youtubeVideo.snippet.resourceId.videoId}`;
      preparedYouTubeVideo = {
        channelTitle: youtubeVideo.snippet.channelTitle,
        videoTitle: youtubeVideo.snippet.title,
        thumbnailSmall: youtubeVideo.snippet.thumbnails.default ? youtubeVideo.snippet.thumbnails.default.url : '',
        videoLink: videoUrl,
      };
      this.youTubeVideos.push(preparedYouTubeVideo);
    }

    this.youtubeVideosReady = true;
  }
}
